import { ulid } from "@std/ulid";
import { char, integer, pgEnum, pgTable, text, timestamp, unique, } from "drizzle-orm/pg-core";
import { createInsertSchema, createSelectSchema, createUpdateSchema, } from "drizzle-orm/zod";
import { z } from "zod";
const customerIdentifierTypeEnum = ["email", "number"];
export const customerIdentifierType = pgEnum("customer_identifier_type", customerIdentifierTypeEnum);
export const CustomerIdentifierTypeSchema = z.enum(customerIdentifierTypeEnum);
CustomerIdentifierTypeSchema;
export const authorizationTokenTable = pgTable("authorization_token", {
    bcId: text().notNull(),
    token: text()
        .primaryKey()
        .$defaultFn(() => ulid().toLowerCase()),
    createdAt: timestamp().defaultNow().notNull(),
});
export const AuthorizationTokenSelectSchema = createSelectSchema(authorizationTokenTable, { token: z.ulid() });
export const AuthorizationTokenInsertSchema = createInsertSchema(authorizationTokenTable, { token: z.ulid().optional() });
export const AuthorizationTokenUpdateSchema = createUpdateSchema(authorizationTokenTable, { token: z.ulid().optional() });
export const customerChangeRequestTable = pgTable("customer_change_request", {
    id: text()
        .primaryKey()
        .$defaultFn(() => ulid().toLowerCase()),
    bcId: text().notNull(),
    property: customerIdentifierType().notNull(),
    value: text().notNull(),
    code: char({ length: 6 }).notNull(),
    tries: integer().default(0).notNull(),
    createdAt: timestamp().defaultNow().notNull(),
}, (t) => [unique().on(t.bcId, t.property)]);
export const CustomerChangeRequestSelectSchema = createSelectSchema(customerChangeRequestTable, {
    id: z.ulid(),
    code: z.string().regex(/^[0-9]{6}$/),
});
export const CustomerChangeRequestInsertSchema = createInsertSchema(customerChangeRequestTable, {
    id: z.ulid().optional(),
    code: z.string().regex(/^[0-9]{6}$/),
});
export const CustomerChangeRequestUpdateSchema = createUpdateSchema(customerChangeRequestTable, {
    id: z.ulid().optional(),
    code: z
        .string()
        .regex(/^[0-9]{6}$/)
        .optional(),
});
export const customerLoginCodeTable = pgTable("customer_login_code", {
    id: text()
        .primaryKey()
        .$defaultFn(() => ulid().toLowerCase()),
    identifier: text().notNull().unique(),
    code: char({ length: 6 }).notNull(),
    tries: integer().default(0).notNull(),
    createdAt: timestamp().defaultNow().notNull(),
});
export const CustomerLoginCodeSelectSchema = createSelectSchema(customerLoginCodeTable, {
    id: z.ulid(),
    identifier: z.union([z.e164().toLowerCase(), z.email().toLowerCase()]),
    code: z.string().regex(/^[0-9]{6}$/),
});
export const CustomerLoginCodeInsertSchema = createInsertSchema(customerLoginCodeTable, {
    id: z.ulid().optional(),
    identifier: z.union([z.e164().toLowerCase(), z.email().toLowerCase()]),
    code: z.string().regex(/^[0-9]{6}$/),
});
export const CustomerLoginCodeUpdateSchema = createUpdateSchema(customerLoginCodeTable, {
    id: z.ulid().optional(),
    identifier: z
        .union([z.e164().toLowerCase(), z.email().toLowerCase()])
        .optional(),
    code: z
        .string()
        .regex(/^[0-9]{6}$/)
        .optional(),
});
